import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import fileDownload from "js-file-download";
import { getAuthHeader } from "src/jwt/config";
import { SERVER_URL } from "src/serverConfig";
import { clientAPI } from "./axiosAnstance";

export const saveFichierAPI = createAsyncThunk(
  "dossier/fichier",
  async (data) => {
    const fichi = JSON.stringify(data.toSave);

    const blob = new Blob([fichi], {
      type: "application/json",
    });

    var formData = new FormData();

    var theFile = data.file;

    formData.append("file", theFile);
    formData.append("fileMeta", blob);
    let token = localStorage.getItem("token");

    const response = axios.post(SERVER_URL + `/api/dossier/save`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      Accept: "application/json",
    });
    return (await response).data;
  }
);

// export const getListTypeFichiersAPI = createAsyncThunk(
//   "dossier/getListTypeFichier",
//   async () => {
//     const response = await clientAPI.get("/api/type_fichier/list/");
//     return response.data;
//   }
// );

export const getDossierAdherentAPI = createAsyncThunk(
  "dossier/getDossierAdherent",
  async (idCompte) => {
    const response = await clientAPI.get("/api/dossier/by_compte/" + idCompte);
    //console.log('le fiche response ::: '+response.data);
    return response.data;
  }
);

export const getFileByAdherentAndType = createAsyncThunk(
  "adherent/getFileByAdherentAndType",
  async (data) => {
    const response = await axios.get(
      SERVER_URL + `/api/fichier/getFile/${data.id_compte}/${data.id_type_fichier}`,
      {
        headers: getAuthHeader(),
        responseType: "blob", // Important pour la réception des fichiers binaires
      }
    );

    const blob = response.data;
    const contentType = response.headers['content-type'];
    const contentDisposition = response.headers['content-disposition'];

    // 1. Déterminer le nom du fichier
    let filename = data.libelle; // Nom par défaut

    // Extraire le nom du fichier depuis Content-Disposition si disponible
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '');
      }
    }

    // 2. Déterminer l'extension si elle n'est pas dans le nom
    if (!filename.includes('.')) {
      let extension = 'pdf'; // Par défaut

      if (contentType) {
        if (contentType.includes('jpeg') || contentType.includes('jpg')) {
          extension = 'jpg';
        } else if (contentType.includes('png')) {
          extension = 'png';
        }
      }
      filename += `.${extension}`;
    }

    // 3. Télécharger le fichier
    fileDownload(blob, filename);

    return blob;
  }
);

// Supprimer un fichier adhérent (dossier)
export const deleteDossierFileAPI = createAsyncThunk(
  "dossier/deleteFile",
  async ({ idAdherent, idFichier }, thunkAPI) => { // 🔹 Modification : objet au lieu de simple ID
    try {
      await clientAPI.delete(`/api/fichier/delete/${idAdherent}/${idFichier}`);
      console.log('delete fichier compte ::  ',idAdherent)
      return { idAdherent, idFichier };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Erreur");
    }
  }
);

export const getFileByAdherentAndTypeFiche = createAsyncThunk(
  "adherent/getFileByAdherentAndTypeFiche",
  async (data) => {
    const response = await axios.get(
      SERVER_URL + `/api/fichier/getFile/${data.id_compte}/${data.id_type_fichier}`,
      {
        headers: getAuthHeader(),
        responseType: "blob",
      }
    );

    const blob = response.data;
    const contentType = response.headers['content-type'];
    const contentDisposition = response.headers['content-disposition'];

    let filename = data.libelle || "document";

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '');
      }
    }

    if (!filename.includes('.')) {
      let extension = 'pdf';
      if (contentType) {
        if (contentType.includes('jpeg') || contentType.includes('jpg')) extension = 'jpg';
        else if (contentType.includes('png')) extension = 'png';
      }
      filename += `.${extension}`;
    }

    // 🔴 SUPPRIMER : fileDownload(blob, filename);

    // 🔴 RETOURNER L'OBJET COMPLET
    return { blob, contentType, contentDisposition, filename };
  }
);
export const getFileByAdherentAndType1 = createAsyncThunk(
  "adherent/getFileByAdherentAndType1",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        SERVER_URL + `/api/fichier/get/${data.id_compte}/${data.id_type_fichier}`,
        {
          headers: getAuthHeader(),
          responseType: "blob", // On s'attend à un fichier
        }
      );

      const blob = response.data;
      console.log('le size de fichier :: ',blob.size)
      // 1. Vérifier si la réponse est vide (statut 204 ou taille 0)
      if (response.status === 204 || blob.size === 0) {
        return rejectWithValue("Le document est vide ou n'existe pas.");
      }


      // 3. Si tout est bon, on retourne le fichier
      return blob;

    } catch (error) {
      // Gérer les erreurs de requête (ex: serveur injoignable)
      return rejectWithValue(
        error.response?.data?.message || "Une erreur réseau est survenue."
      );
    }
  }
);
export const deleteFichierAPI = createAsyncThunk(
  "dossier/deleteFichierAPI",
  async (id) => {
    const response = await clientAPI.delete("/api/fichier/delete/" + id);
    return response.data;
  }
);

const DossierNumericSlice = createSlice({
  name: "dossier",
  initialState: {
    // typeFichiers: [],
    listFichiers: [],
    listFichierStatus: null,
    saveFichierStatus: null,
  },
  reducers: {
    resetDossierNumerique: (state, action) => {
      state.listFichiers = [];
      state.listFichierStatus = null;
      state.saveFichierStatus = null;
    },
  },
  extraReducers: {
    // -------------- saveFichierAPI ---------------
    [saveFichierAPI.pending]: (state, action) => {
      state.saveFichierStatus = "pending";
    },
    [saveFichierAPI.fulfilled]: (state, action) => {
      state.saveFichierStatus = "fulfilled";
    },
    [saveFichierAPI.rejected]: (state, action) => {
      state.saveFichierStatus = "rejected";
    },

    // -------------- getDossierAdherentAPI ---------------
    [getDossierAdherentAPI.pending]: (state, action) => {
      state.listFichierStatus = "pending";
    },
    [getDossierAdherentAPI.fulfilled]: (state, action) => {
      state.listFichierStatus = "fulfilled";
      state.listFichiers = action.payload;
    },
    [getDossierAdherentAPI.rejected]: (state, action) => {
      state.listFichierStatus = "rejected";
    },
  },
});

export const saveFileStatusSelector = (state) =>
  state.dossier.saveFichierStatus;

export const { resetDossierNumerique } = DossierNumericSlice.actions;

export default DossierNumericSlice.reducer;
